//@ts-check

import React, { useRef, useState } from 'react';
import InputField from 'components/Form/Input/input-field';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import { getThemeColor } from 'store/settings';
import { parseHtml } from 'helpers';
import stylespopover from 'styles/Calendar.module.scss';
import { Popover } from 'antd';
import { HelpCircle } from 'react-feather';

const Stylescal = styled.div`
  .textarea-counter-value {
    background-color: ${(props) => props.themeStatus} !important;
    color: #fff;
    padding: 1px 6px;
    font-size: 0.6rem;
    border-radius: 0 0 5px 5px;
    margin-right: 1rem;
  }
`;

const FreeText = ({
  value = '',
  onChange,
  className = '',
  explanation,
  isFullscreenMode,
  readOnly,
}) => {
  const themeStatus = useSelector(getThemeColor);
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);
  const hide = () => {
    setOpen(false);
  };
  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };
  return (
    <div className={className} ref={containerRef}>
      <Popover
        {...(isFullscreenMode
          ? { getPopupContainer: () => containerRef.current }
          : {})}
        placement={isFullscreenMode ? 'left' : 'top'}
        content={
          <div
            className={`Popover-responsive  ${stylespopover.Popover_responsive}`}
            onClick={hide}
          >
            {parseHtml(explanation)}
          </div>
        }
        trigger="click"
        open={open}
        onOpenChange={handleOpenChange}
      >
        {explanation && (
          <HelpCircle
            aria-label="View explanation"
            className="free-text-icon mt-1 float-right mb-1 position-relative"
            size={16}
            style={{
              color: 'var(--course-unit-status-icon-clr)',
              cursor: 'pointer',
              zIndex: 20,
            }}
          />
        )}
      </Popover>
      <InputField
        value={value}
        onChange={(e) => onChange(e.target.value)}
        readOnly={readOnly}
        type="textarea"
        rows={5}
        className="w-100"
        maxLength={500}
      />
      <Stylescal themeStatus={themeStatus}>
        <span className="textarea-counter-value float-right">
          {value?.length || 0}/{500}
        </span>
      </Stylescal>
    </div>
  );
};

export default FreeText;
